const removeSymbols = (string) => string.replace(/\W/g, '');

const getSystemCommentCreator = (comment) => (comment.text ? removeSymbols(comment.text).charAt(0) : '-');

const getUserCommentCreator = (comment) => (comment.creator ? comment.creator.charAt(0) : '-');

const getCommentCreator = (comment) => (comment.comment_type === 'system' ? getSystemCommentCreator(comment) : getUserCommentCreator(comment));

export default getCommentCreator;
